import { authApi, BriefPublicUserProfile, PublicUserProfile } from '@app/services'
import {
  useAuthFollowUserMutation,
  useAuthGetFolloweesQuery,
  useAuthUnfollowUserMutation,
} from '@app/services/auto-generated/auth'
import { Button } from '@common/components'
import { useAppDispatch } from '@common/hooks'
import { PersonAddAltIcon, PersonOffIcon } from '@common/icons'
import { useUser } from '@features/auth/hooks'
import FollowLimitUpgradeModal from '@features/payment/components/follow-limit-upgrade-modal/follow-limit-upgrade-modal'
import { SxProps } from '@mui/material'
import { useState } from 'react'

const FollowUser = (props: {
  userToFollow: PublicUserProfile | BriefPublicUserProfile
  sx?: SxProps
  onError?: (error: any) => void
}) => {
  const { userToFollow, onError } = props
  const { user: userAuth } = useUser()
  const dispatch = useAppDispatch()
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  const { data: listFollowees, isLoading } = useAuthGetFolloweesQuery(
    {
      userId: userAuth?.id as number,
    },
    { skip: !userAuth?.id },
  )

  const [follow] = useAuthFollowUserMutation()
  const [unfollow] = useAuthUnfollowUserMutation()

  const handleFollow = async () => {
    if (userToFollow) {
      const patchResult = dispatch(
        authApi.util.updateQueryData(
          'authGetFollowees',
          { userId: userAuth?.id as number },
          (draft) => {
            if (draft?.some((user) => user.id === userToFollow?.id)) {
              return (draft = draft?.filter((user) => user.id !== userToFollow?.id))
            } else draft = draft?.push(userToFollow)
          },
        ),
      )
      try {
        if (listFollowees?.some((user) => user.id === userToFollow?.id)) {
          await unfollow({ userId: userToFollow?.id as number }).unwrap()
        } else {
          await follow({ userId: userToFollow?.id as number }).unwrap()
        }
      } catch (error: any) {
        patchResult.undo()
        // Check for follow limit error
        if (!onError && error?.data?.detail?.error_code === 'EXC_FOLLOW_LIMIT_REACHED') {
          setShowUpgradeModal(true)
        }
        // Call the error callback if provided
        onError?.(error)
      }
    }
  }

  if (!userToFollow?.id) return null
  return (
    <>
      <Button
        {...props}
        loading={isLoading}
        color={listFollowees?.some((user) => user.id === userToFollow?.id) ? 'neutral' : 'primary'}
        variant='contained'
        onClick={handleFollow}
        sx={{ borderRadius: '15px', fontWeight: '600', width: '130px', ...props.sx }}
      >
        {listFollowees?.some((user) => user.id === userToFollow?.id) ? (
          <>
            <PersonOffIcon fontSize='small' sx={{ mr: 0.5 }} />
            Unfollow
          </>
        ) : (
          <>
            <PersonAddAltIcon fontSize='small' sx={{ mr: 0.5 }} />
            Follow
          </>
        )}
      </Button>

      <FollowLimitUpgradeModal open={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />
    </>
  )
}

export default FollowUser
